export default __webpack_public_path__ + "static/media/paused-sub-bg@2x.85da6c3c.png";